<script lang="ts" setup>
import BasicButton from '~/components/form-elements/BasicButton.vue'
import BasicInput from '~/components/form-elements/BasicInput.vue'
import CustomModalWindow from '~/components/modal-windows/CustomModalWindow.vue'

const model = defineModel<boolean>()

const props = withDefaults(
  defineProps<{
    buttonTitle?: string
    cancelButtonTitle?: string
    challengeAnswer?: string | null
    challengeInputLabelText?: string | null
    confirmButtonColor?: 'black' | 'blue' | 'body-background' | 'gray' | 'green' | 'light-gray' | 'light-yellow' | 'red' | 'white'
    title?: string
    warningText?: string | null
  }>(),
  {
    buttonTitle: 'Подтвердить',
    cancelButtonTitle: 'Не\xA0подтверждать',
    challengeAnswer: null,
    challengeInputLabelText: null,
    confirmButtonColor: 'green',
    title: 'Подтверждение действия',
    warningText: null
  }
)

const emit = defineEmits<{
  (e: 'confirmAction'): void
}>()

const answer = ref<string | null>(null)
const isConfirming = ref(false)

const isConfirmActionButtonDisabled = computed(() => {
  const { challengeAnswer } = props

  if (challengeAnswer) {
    return answer.value !== challengeAnswer
  }

  return false
})

function close (): void {
  model.value = false
}

function confirmAction (): void {
  isConfirming.value = true

  emit('confirmAction')

  close()
}
</script>

<template>
  <CustomModalWindow v-model="model">
    <template #title>
      {{ title }}
    </template>

    <Notification v-if="warningText" class="mb-6" is-small status="warning">
      {{ warningText }}
    </Notification>

    <BasicInput
      v-if="challengeAnswer"
      v-model="answer"
      class="mb-6"
      description="Требуется для подтверждения действия."
      is-required
      :label-text="challengeInputLabelText"
    />

    <div class="flex space-x-2">
      <BasicButton v-if="!isConfirming" color="body-background" :title="cancelButtonTitle" @click="close" />

      <BasicButton
        :color="confirmButtonColor"
        :is-disabled="isConfirmActionButtonDisabled"
        :is-loading="isConfirming"
        :title="buttonTitle"
        @click="confirmAction"
      />
    </div>
  </CustomModalWindow>
</template>
